import { NavLink } from 'react-router-dom';
import { primaryNav } from '../navigation';
import { useWorkspace } from '../WorkspaceContext';

const WorkspaceNav = () => {
  const { badges } = useWorkspace();

  return (
    <nav aria-label="Primary" className="bg-ink-950">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="scrollbar-hide flex items-stretch overflow-x-auto sm:justify-center">
          {primaryNav.map((item) => {
            const badge = badges?.[item.id] || 0;

            return (
              <NavLink
                key={item.id}
                to={item.path}
                end={item.id === 'clients' || item.id === 'calendar' || item.id === 'marketing'}
                data-tour={item.id === 'manage' ? 'nav-manage' : undefined}
                className={({ isActive }) =>
                  `relative flex flex-none items-center gap-2 px-4 py-4 text-sm transition-colors duration-200 sm:px-6 ${
                    isActive
                      ? 'font-semibold text-sand-50'
                      : 'text-sand-200/70 hover:text-sand-50'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className="whitespace-nowrap">{item.label}</span>
                    {badge > 0 && (
                      <span className="inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-saffron-500 px-1.5 text-[11px] font-semibold text-ink-900">
                        {badge > 99 ? '99+' : badge}
                      </span>
                    )}
                    {isActive && (
                      <span
                        aria-hidden="true"
                        className="absolute inset-x-3 bottom-0 h-[3px] bg-saffron-500 sm:inset-x-5"
                      />
                    )}
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default WorkspaceNav;
